import Main from 'modules/Statistics/Main/Main'
import Sagas from 'modules/Statistics/Main/saga'
import Reducer from 'modules/Statistics/Main/reducer'

export default Main

export { Sagas, Reducer }
